import { useSearchParams } from 'react-router-dom';
import { LoungeScreen } from '../../shared/components/Lounge';

const MESSAGES = {
  falta_token:     'El código QR no es válido.',
  qr_invalido:     'El código QR no es válido o ya expiró.',
  sin_cupo:        'Este QR ya no tiene canciones disponibles.',
  acceso_invalido: 'Acceso inválido. Escanea el QR nuevamente.',
  sin_conexion:    'No pudimos conectar con la sala. Espera unos segundos y escanea el QR de nuevo.',
  sala_inactiva:   'Esta sala no está activa por el momento. Consulta con el local.',
};

export function ErrorPage() {
  const [params] = useSearchParams();
  const text = MESSAGES[params.get('msg')] ?? 'Ocurrió un error inesperado.';

  return (
    <LoungeScreen>
      <span className="relative mb-4 inline-flex items-center gap-2 rounded-full border border-lounge-line bg-lounge-card
                       px-3 py-1 font-mono text-[11px] uppercase tracking-[0.2em] text-lounge-stone">
        <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-stop" />
        Sala no disponible
      </span>
      <h1 className="relative font-serif text-[40px] font-semibold leading-[1.1] tracking-tight">
        Algo no<br />
        <span className="italic text-lounge-brass">salió bien.</span>
      </h1>
      <p role="alert" className="relative mt-4 max-w-[300px] text-base leading-relaxed text-lounge-stone">{text}</p>
    </LoungeScreen>
  );
}
